/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PecegepayBilletPdf200,
  GetApiV1PecegepayBilletPdf401,
  GetApiV1PecegepayBilletPdf404,
  GetApiV1PecegepayBilletPdf500,
  GetApiV1PecegepayBilletPdfQueryParams,
  GetApiV1PecegepayBilletPdfQueryResponse,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletPdf.ts";

export const getApiV1PecegepayBilletPdfQueryParamsSchema = z
  .object({
    pdfFileUrl: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1PecegepayBilletPdfQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PecegepayBilletPdf200Schema = z.instanceof(
  File,
) as unknown as ToZod<GetApiV1PecegepayBilletPdf200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PecegepayBilletPdf401Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletPdf401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PecegepayBilletPdf404Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletPdf404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PecegepayBilletPdf500Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletPdf500>;

export const getApiV1PecegepayBilletPdfQueryResponseSchema = z.lazy(
  () => getApiV1PecegepayBilletPdf200Schema,
) as unknown as ToZod<GetApiV1PecegepayBilletPdfQueryResponse>;
